/* eslint-disable react-hooks/exhaustive-deps */
// External deps
import { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';

// Internal deps
import SendToApproveAllLines from '../SendToApproveAllLines/SendToApproveAllLines';
import useWorkReport from '../../../../hooks/useWorkReport';
import NoWorkReports from '../../NoWorkReports';
import { PositionLinePermissions } from '../../../MonthlyServiceRequest/RequestDetailTypes';
import { formatFullDate, formatsEnum } from '../../../../utils/formatUtils';
import { useFilterContext } from '../../../../context/FilterDetailSDSContext';

import PositionRowContainer from './PositionRowContainer/PositionRowContainer';

import './WeeklyView.scss';

const WeeklyView = ({
  newFetch,
  setNewFetch,
  positionLinesPermissions,
  typeOfUbication,
  disabledEditStateCancelOrFinish,
  forceWindow,
  isOyM
}) => {
  const today = formatFullDate(new Date(), formatsEnum.FORMAT_DATE_2);

  const [reportList, setReportList] = useState([]);
  const [changeInLine, setChangeInLine] = useState(false);

  const form = useRef();

  const { filter } = useFilterContext();

  const { fetchLinesByWeek, linesByWeek, workReportId, startDate, calendarDate } = useWorkReport();

  const createReportList = () => {
    const dailyReport = [];

    if (form?.current?.values?.position?.length) {
      form?.current?.values?.position?.forEach((position) => {
        position?.lineas?.forEach((line) => {
          line.partesDiarios?.forEach((dailyRep) => {
            if (
              dailyRep.estadoEnum !== 1 ||
              dailyRep.estadoEnum !== 4 ||
              (dailyRep.cantidad &&
                today > formatFullDate(dailyRep.fecha, formatsEnum.FORMAT_DATE_2))
            ) {
              dailyReport.push({
                ...dailyRep,
                idParteDiario: dailyRep.id,
                cantidad: dailyRep.cantidad
              });
            }
          });
        });
      });
      setReportList(dailyReport);
    }
  };

  useEffect(() => {
    fetchLinesByWeek(undefined, undefined, filter);
  }, [workReportId, startDate, newFetch, filter]);

  useEffect(() => {
    form.current.setValues({
      position: linesByWeek
    });
  }, [linesByWeek]);

  useEffect(() => {
    createReportList();
  }, [form?.current?.values, changeInLine]);

  const initialValues = {
    position: []
  };

  return (
    <>
      <Formik initialValues={initialValues} innerRef={form}>
        {({ values }) => (
          <Form>
            {values?.position?.length ? (
              <ul className="weekly_list_container">
                {values?.position?.map((position, index) => (
                  <li key={`${index.toString()}-${position.numeroPosicion}`}>
                    <PositionRowContainer
                      changeInLine={changeInLine}
                      disabledEditStateCancelOrFinish={disabledEditStateCancelOrFinish}
                      forceWindow={forceWindow}
                      indexPosition={index}
                      isOyM={isOyM}
                      newFetch={newFetch}
                      position={position}
                      positionLinesPermissions={positionLinesPermissions}
                      selectedDate={calendarDate}
                      setChangeInLine={setChangeInLine}
                      setNewFetch={setNewFetch}
                      startDate={startDate}
                      typeOfUbication={typeOfUbication}
                      workReportId={workReportId}
                    />
                  </li>
                ))}
              </ul>
            ) : (
              <NoWorkReports title="No disponés de líneas para la fecha seleccionada" />
            )}
          </Form>
        )}
      </Formik>

      {linesByWeek.length ? (
        <SendToApproveAllLines
          disabledByRol={!positionLinesPermissions.sendToApprove}
          newFetch={newFetch}
          selectedDate={calendarDate}
          setNewFetch={setNewFetch}
          workReportId={workReportId}
          workReportLines={reportList}
        />
      ) : null}
    </>
  );
};

WeeklyView.propTypes = {
  setNewFetch: PropTypes.func.isRequired,
  newFetch: PropTypes.bool.isRequired,
  disabledEditStateCancelOrFinish: PropTypes.bool.isRequired,
  typeOfUbication: PropTypes.shape({
    id: PropTypes.number,
    nombre: PropTypes.string
  }).isRequired,
  positionLinesPermissions: PositionLinePermissions.isRequired,
  forceWindow: PropTypes.bool,
  isOyM: PropTypes.bool
};
WeeklyView.defaultProps = {
  forceWindow: null,
  isOyM: false
};

export default WeeklyView;
